import { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import Style from './DeliveryBottomNavigation.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClipboardList, faMapPin } from "@fortawesome/free-solid-svg-icons"
const DeliveryBottomNavigation = () => {
    const location=useLocation()
    const[newRequestPageState,setNewPageRequestState]=useState(false)
    const[AllRequestPageState,setAllRequestPageState]=useState(true)

    
    useEffect(()=>{
        if(window.location.pathname==='/current')
        {
            setNewPageRequestState(true)
            setAllRequestPageState(false)

        }
        if(window.location.pathname==='/deliveryrequest')
        {
            setNewPageRequestState(false)
            setAllRequestPageState(true)
 
        }
    },[location])
  return (
    <ul className={Style.menufixed}>
    <Link to='/newdeliveryrequest' >
    <li className={newRequestPageState?Style.menufixed__li__click: Style.menufixed__li}> 
        <FontAwesomeIcon icon={faMapPin}/>
        <h2 className={Style.h2}>درخواست جدید</h2>
    </li>
    </Link>
    <Link to='/deliveryrequest' >
    <li className={AllRequestPageState?Style.menufixed__li__click: Style.menufixed__li}>
        <FontAwesomeIcon  icon={faClipboardList}/>
        <h2 className={Style.h2}>درخواست ها</h2> 
    </li>
    </Link>
</ul>
  )
}

export default DeliveryBottomNavigation